import { getOrgId } from '../utilities';
import { ConversationApiService } from '../services/conversations';

export const getConversations = async (
  organizationId?: string
): Promise<ShortConversationType[]> => {
  const userId = window.AiAgentsWebWidget?.getUserId?.() || undefined;

  const { conversations } = await ConversationApiService.getConversations(
    organizationId || getOrgId(),
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    userId,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    undefined,
    0,
    3
  );

  if (!conversations) return [];

  return conversations
    .map(
      (item): ShortConversationType => ({
        id: item.id || '',
        name: item.title || ' - ',
      })
    )
    .filter(item => !!item.id);
};

export const getConversation = (id: string) => {
  return {};
};
